"use client";

import { useEffect, useRef, useState } from "react";
export default function BrandsWeWorkWith() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  const brands = [{
    name: "TechCorp",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_techcorp_logo.png"
  }, {
    name: "InnovateLab",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_innovatelab_logo.png"
  }, {
    name: "CloudSystems",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_cloudsystems_logo.png"
  }, {
    name: "DataFlow",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_dataflow_logo.png"
  }, {
    name: "NexGen",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_nexgen_logo.png"
  }, {
    name: "SmartWare",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_smartware_logo.png"
  }, {
    name: "FutureNet",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_futurenet_logo.png"
  }, {
    name: "CodeMasters",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_codemasters_logo.png"
  }, {
    name: "PixelPro",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_pixelpro_logo.png"
  }, {
    name: "WebSphere",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_websphere_logo.png"
  }, {
    name: "GlobalTech",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_globaltech_logo.png"
  }, {
    name: "DigiHub",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/brand_digihub_logo.png"
  }];
  const duplicatedBrands = [...brands, ...brands];
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let animationFrameId: number;
    let scrollPosition = 0;
    const scrollSpeed = 0.5;
    const animate = () => {
      if (!isPaused && scrollContainer) {
        scrollPosition += scrollSpeed;
        const maxScroll = scrollContainer.scrollWidth / 2;
        if (scrollPosition >= maxScroll) {
          scrollPosition = 0;
        }
        scrollContainer.scrollLeft = scrollPosition;
      }
      animationFrameId = requestAnimationFrame(animate);
    };
    animate();
    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [isPaused]);
  return;
}